import React from 'react'
import Header from '../Header'
import Title from '../Title'
import Form from './Form'

export default (props) => (
  <>
    <Header />
    <Title>
      Send your results to your inbox
    </Title>
    <Form {...props} />
  </>
)
